
<template>
  <v-choose
    ref="deviceSelect"
    :is_group="is_group"
    :areaid="areaid"
    :area-tree-type="areaTreeType"
    :execute-type="executeType"
    :is-compare="isCompare"
    :displaynoarea="displaynoarea"
    :checkeddata="checkeddata"
    :is-sence="isSence"
    :is-ifttt="isIfttt"
    :class-skus="classSkus"
    :child-category-type="childCategoryType"
    :device-category-type="deviceCategoryType"
    :is-need-same-device-status="isNeedSameDeviceStatus"
    :required-message-type="requiredMessageType"
    :gateway-v-device-id="gatewayVDeviceId"
    :only-class-sku="onlyClassSku"
    :get-device-list-fn="getDeviceListFn"
    :is-visual="isVisual"
    :multiple-dialog-group="multipleDialogGroup"
    :only-compare-device="onlyCompareDevice"
    :multipleDialogGroup="multipleDialogGroup"
    :requiredMaxDevice="requiredMaxDevice"
    :maxDevice="maxDevice"
    :hasSelectDevice="hasSelectDevice"
    :hideTree="hideTree"
    :bindStatus="bindStatus"
    @confirm="confirm"
    @chooseDeviceInMap="chooseDeviceInMap"
  />
</template>

<script>
import vChoose from '@/components/common/deviceChoose.vue';
import { CreateHCL, FindHCL, EditHCL, FindSysHCLTemplateList} from '@/axios/IHcl.js';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';
import DeviceHandler from '@/utils/deviceHandler.js';
export default {
  components: {
    vChoose,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    is_group: {
      type: Boolean,
      default: false,
    },
    areaid: {
      type: Number,
      default: -1,
    },
    areaTreeType: {
      type: Number,
      default: 1,
    },
    executeType: {
      type: Number,
      default: 2,
    },
    isCompare: {
      type: Boolean,
      default: true,
    },
    displaynoarea: {
      type: Boolean,
      default: true,
    },
    isSence: {
      type: Boolean,
      default: false,
    },
    isIfttt: {
      type: Boolean,
      default: false,
    },
    classSkus: {
      type: String,
      default: '',
    },
    constantid: {
      type: Number,
      default: -1 //恒照度id
    },
    childCategoryType: {
      type: [String, Number],
      default: () => '',
    },
    isNeedSameDeviceStatus: {
      type: Number,
      default: 0,
    },
    checkeddata: {
      type: Array,
      default: () => [],
    },
    deviceCategoryType: {
      type: [String, Number],
      default: null
    },
    gatewayVDeviceId:{
      type: String,
      default: ''
    },
    onlyClassSku: {
      type: Array,
      default: () => [],
    },
    requiredMessageType: {
      type: String,
      default: null
    },
    getDeviceListFn: {
      type: Function,
      default: null
    },
    isVisual: {
      type: Boolean,
      default: false
    },
     // 自动化选中设备不过滤,并且卡片标上已选状态
     multipleDialogGroup:{
      type: Boolean,
      default: false
    },
    onlyCompareDevice: {
      type: Boolean,
      default: false
    },
    //是否支持最大设备选择
    requiredMaxDevice: {
      type: Boolean,
      default:false
    },
    //最多选择几个设备
    maxDevice: {
      type: Number,
      default: 0
    },
     //已经选择了几个设备
     hasSelectDevice: {
      type: Number,
      default: 0
    },
    //是否隐藏tree
    hideTree:{
      type:Boolean,
      default:false
    },
    // 是否真实设备 -1-全部 0-虚拟设备 1-真实设备
    bindStatus:{
      type: Number,
      default: -1 
    }

  },
  data() {
    console.log('.....hideTree',this.hideTree)
    return {
      radio1: '', //选择的网关
      cardList: [], //设备集合
      checkDevice: [], //选中的设备集合
      select: false, // 全选按钮
      groupSiftOptions: []
    };
  },
  watch: {
    requiredMessageType(sss) {
      console.log('vvvv 2', sss);
      
    }
  },
  destroyed() {
  },
  created() {
  },
  mounted() {
    // this.areaid = this.gpNo;
    this.doFindination();
    this.doFindScene();
    console.log('vvvv 3', this.requiredMessageType)
  },
  methods: {
    chooseDeviceInMap(checckdata,alreadychecked){
      console.log("🚀 ~ chooseDeviceInMap ~ deviceList:", checckdata,alreadychecked)
      this.$emit('chooseDeviceInMap',checckdata,alreadychecked);
    },
    refresh() {      
      this.$refs.deviceSelect.refresh && this.$refs.deviceSelect.refresh()
    },
    // 点击下一步
    confirm(deviceList, groupList) {
      if (!deviceList || deviceList.length === 0) return;

      this.removeTreeDevice(deviceList);
      this.createGrop();

      const deviceHandler = new DeviceHandler({ deviceList, groupList });

      deviceHandler.getCheckedDeviceList().then(res => {
        this.checkDevice = res;

        this.$emit('confirm', res);
      })
    },

    /* 点击选中设备
    * list 点击对象
    */
    removeTreeDevice(list) {
      //选中的设备
      this.cardList = list;
      this.getCheckedDataDevice();
    },

    /* 获得选中的设备
    */
    getCheckedDataDevice() {
      // 选择的
      const selectedCardList = this.cardList.filter(item => !!item.ischecked);
      const totalCard = this.getCardTolal();

      // 是否全选
      this.select = selectedCardList.length === totalCard;
      this.checkDevice = selectedCardList;
    },

    /**
     * 展示的卡片个数
     */
    getCardTolal() {
      return this.cardList.filter(item => !item.hidden).length;
    },
  
    /* 页面初始化查询节律
    */
    doFindination() {
      if (this.constantid != -1 && this.constantid != null) {
        var para = { hclId: this.constantid };
        FindHCL(para, this.functionDoFind);
        para = null;
      } else {
        var _param = this.$store.state.areasGpName[this.areaid];
        _param = _param && _param["GpName"] + '.';
        this.name = _param + this.$t('ifttt.hcl');
        _param = null;
      }
      FindSysHCLTemplateList({ platformType: 1 }, this.functionDoFindSysHCLTemplate)
    },

    doFindScene() {
      const controlAche = getLocalStoragItem("control");

      if (!controlAche) return;

      const param = JSON.parse(
        getLocalStoragItem("control")
      );

      if (param.SceneNo !== void 0) {
        // FindScene({ sceneNo: this.parameters.SceneNo }, this.functionDoFindScene);
      }
    },

    functionDoFindScene(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode && rs.Result) {
          // this.parameters.GpNo = rs.Result.GpNo;
          // this.parameters.ConfigStatus = rs.Result.ConfigStatus;
          // this.parameters.ParentAreaNames = rs.Result.ParentAreaNames;
          // this.scenlist = rs.Result;
          // this.nameValue = this.scenlist.SecneName;
          // this.selectvalue = this.scenlist.SceneType;

          // this.groupSiftValue = "";
          // this.groupSiftOptions = [];
          if (Array.isArray(rs.Result.CustomGroups)) {
            this.groupSiftOptions = rs.Result.CustomGroups;
          }

          // this.skuSiftValue = "";
          // this.skuSiftOptions = [];
          // this.addcheckdata(this.scenlist.DeviceList);
      }
    },

    functionDoFindSysHCLTemplate(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.templateData = rs.Result
      }
    },
    // 666
    getPostFunParam() {
      var param = {
        _gpNo: this.areaid,
        deviceType: 2,
        pageIndex: 1,
        pageSize: this.$store.state.pageTotalLimit,
      };

      if (
        this.rhythmModel &&
        this.rhythmModel.HCLId !== null
      ) {
        param.hclId = this.rhythmModel.HCLId;
      }

      return param;
    },
    /* 选择 好设备 点击确定
    */
    createGrop() {
      if (this.doVerification(false)) {
        if (this.activeStep < 3) {
          this.activeStep = this.activeStep + 1;
        } else {
          this.activeStep = 3;
        }
      }
    },
    /* 验证要提交的数据 是否符合
    */
    doVerification(ispost) {
      if (this.checkDevice.length == 0 && this.isGroupPost == false) {
        warning(this, this.$t('ifttt.warning1'));
        return false;
      } else if (ispost) {
          if (this.lightTimeList.length > 2) {
            return true;
          } else {
            warning(this, this.$t('ifttt.warning2'));
            return false;
          }
        } else {
          return true;
        }
    },
  
    /* 去保存数据 接口返回数据处理
    * rs 接口返回数据包
    */
    functionDoNotice(rs, para) {
      this.btnloading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.$emit('RhythmOK', para.GpNo);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 按钮点击保存执行
    */
    // save() {
    //   this.doSave();
    // },
    /* 全选
    */
    checkAll(e) {
      if (e) {
        this.select = true;
      } else {
        this.select = false;
      }
      this.selectCheckBox(e);
    },
    /* 执行全选操作
    */
    selectCheckBox(_flag) {
      var _arr = [];
      this.cardList.forEach(item => {
        if (!item.isdisabled) {
          item.ischecked = _flag; //全选
        }
        _arr.push(item);
      });
      this.cardlist = _arr;
      this.getCheckedDataDevice();
      _arr = null;
    },
    // 获取日期的时间戳
    gettimeStamp(time) {
      return new Date(time.replace(/-/g, '/')).getTime();
    },

    // 给父组件获取选择的设备
    getCheckDevice() {
      return this.checkDevice;
    },

    getGroupSiftOptions() {
      return this.groupSiftOptions;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>